import {
  Autorenew,
  UploadFile,
  Assessment,
  Receipt,
  People,
  WhatsApp,
  Payment,
  BusinessCenter,
  Send,
  Visibility,
  Add,
  Google,
  Email,
  PersonAdd,
  Edit,
  Delete,
  TuneOutlined,
  DeleteOutline,
  DeleteForever,
  Language,
} from "@mui/icons-material";
import {
  Autocomplete,
  Button,
  TextField,
  Tabs,
  Tab,
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Divider,
  Avatar,
  FormControlLabel,
  Switch,
  Select,
  MenuItem,
  Checkbox,
  Menu,
  LinearProgress,
} from "@mui/material";
import axios from "axios";
import Sidebar from "components/Sidebar/Sidebar";
import { MiniSpinner } from "components/Spinner";
import { useAuth } from "context/auth/auth";
import { useLayout } from "context/layout/layout";
import { useStore } from "context/store/store";
import React, { useEffect, useState, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { defaultMember } from "utils/state";
import config from "../../../services/config";
import "./index.css";

import medal from "../../../assets/white.png";
import PDFUploader from "components/pdf-uploader";
import {
  Folder,
  MoreVertical,
  Star,
  Share2,
  Download,
  Trash2,
  ArrowLeft,
  FileText,
  Image,
  Video,
  Music,
  File,
  Grid3X3,
  List,
  CheckCircleIcon,
  AttachFileIcon,
  FolderPlus,
  Upload,
} from "lucide-react";

import { Send as SendIcon, AttachFile } from "@mui/icons-material";

import pdfIcon from "../../../assets/filetype-pdf.svg";
import { templates } from "views/makreting-list/templates";
import { colors } from "utils/theme";
import { CreateFolderModal } from "components/CreateFolderModal";
import { DriveErrorState } from "components/DriveErrorState";
import {
  validateFile,
  createUploadQueue,
  renameFolder as renameDriveFolderApi,
  deleteFolder as deleteDriveFolderApi,
  syncMemberDrive as syncMemberDriveApi,
  fetchFolderFiles,
} from "services/gdrive";
import { PortalService } from "services/portal";

export const MemberDetailsV2 = () => {
  return (
    <>
      <Sidebar />
      <Wrapper>
        <ClientPortal />
      </Wrapper>
    </>
  );
};

const Wrapper = ({ children }) => {
  return (
    <div className="relative h-full" style={{ marginLeft: 210 }}>
      <div className="relative h-full" style={{ paddingBottom: 95 }}></div>
      <div
        className="mx-auto w-full -m-24"
        style={{
          height: "100vh",
          backgroundColor: "#fff",
          backgroundImage: "linear-gradient(to bottom, #f8fafc, #f1f5f9)",
        }}
      >
        <div
          className="flex flex-wrap h-full overflow-auto"
          style={{ backgroundColor: "transparent" }}
        >
          <div
            className="w-full h-full"
            style={{ backgroundColor: "transparent" }}
          >
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

function ClientPortal() {
  const auth = useAuth();
  const params = useParams();
  const layout = useLayout();
  const store = useStore();
  const [loading, setLoading] = React.useState(false);
  const [user, setUser] = React.useState(defaultMember);
  const [memberships, setMemberships] = useState([]);
  const [subscriptionType, setSubcriptionType] = useState("Mensual");
  const [activeTab, setActiveTab] = useState(0);
  const [newEmail, setNewEmail] = useState("");

  const navigate = useNavigate();

  // Fetch memberships

  // Estados para los diferentes módulos
  const [invoices, setInvoices] = useState([]);
  const [workers, setWorkers] = useState([]);
  const [users, setUsers] = useState([]);

  useEffect(() => {
    // Cargar datos iniciales
    loadMemberships();
    loadUserData();
    loadUsers();
  }, [params._id]);

  const loadUsers = async () => {
    try {
      const { data } = await axios.get(`${config.url}/users/showall`);
      setUsers(data);
    } catch (err) {
      console.log(err);
    }
  };

  const loadMemberships = async () => {
    try {
      const { data } = await axios.get(`${config.url}/membership/list`);
      setMemberships(data);
    } catch (err) {
      console.log(err);
    }
  };

  const loadUserData = async () => {
    try {
      const res = await fetch(`${config.url}/members/find`, {
        method: "POST",
        body: JSON.stringify({ _id: params._id }),
        headers: { "Content-Type": "application/json" },
      });
      const response = await res.json();
      let start = new Date(response.subscription.startDate);
      let startDate = start.toISOString().slice(0, 10);
      setUser({
        ...response,
        subscription: {
          ...response.subscription,
          startDate: startDate,
        },
      });
    } catch (err) {
      console.log({ err });
    }
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const payload = {
        ...user,
        owner: user.owner?._id || user.owner || null,
      };
      console.log(payload);
      const res = await store.editMember(payload);
      setLoading(false);
      layout.successAlert({ message: "Usuario actualizado con éxito" });
      navigate(-1);
    } catch (err) {
      setLoading(false);
      console.log(err);
      layout.errorAlert({ message: "Error al actualizar el usuario" });
    }
  };

  const handleMoveFolder = async (folderId, oldParentId, newParentId, memberId, newOwnerId) => {
    try {
      setLoading(true);
      const response = await fetch(`${config.url}/gdrive/move-folder`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ folderId, oldParentId, newParentId, memberId, newOwnerId }),
      });
      if (response.ok) {
        layout.successAlert({ message: "Carpeta movida exitosamente" });
        await loadUserData();
      } else {
        const err = await response.json();
        layout.errorAlert({ message: err.error || "Error al mover la carpeta" });
      }
    } catch (err) {
      console.error(err);
      layout.errorAlert({ message: "Error al mover la carpeta" });
    } finally {
      setLoading(false);
    }
  };

  const handleInitDrive = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${config.url}/gdrive/init-member-drive`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ memberId: user._id }),
      });
      if (response.ok) {
        layout.successAlert({ message: "Carpetas de Google Drive creadas exitosamente" });
        await loadUserData();
      } else {
        const err = await response.json();
        layout.errorAlert({ message: err.error || "Error al crear carpetas" });
      }
    } catch (err) {
      console.error(err);
      layout.errorAlert({ message: "Error al crear carpetas de Drive" });
    } finally {
      setLoading(false);
    }
  };

  const handleRenew = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${config.url}/members/renew/${user._id}`, {
        method: "POST",
        body: JSON.stringify({ subscriptionType }),
        headers: { "Content-type": "application/json" },
      });
      const response = await res.json();
      setLoading(false);
      layout.successAlert({ message: "Usuario actualizado con éxito" });
      navigate("/admin/members");
    } catch (err) {
      layout.errorAlert({ message: "Error en el servicio" });
      setLoading(false);
    }
  };

  const sendWhatsApp = (phone, message) => {
    const url = `https://wa.me/${phone.replace(
      /\D/g,
      ""
    )}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");
  };

  const getStatusColor = (status) => {
    switch (status.toLowerCase()) {
      case "pagada":
      case "enviado":
      case "activo":
        return "success";
      case "pendiente":
      case "revisión":
        return "warning";
      case "vencida":
      case "inactivo":
        return "error";
      default:
        return "default";
    }
  };
  const [newTag, setNewTag] = useState("");
  const [showTagInput, setShowTagInput] = useState(false);

  // Predefined tags (customize as needed)
  const predefinedTags = ["En prueba", "Corporativo"];

  // Helper function to handle adding tags
  const handleAddTag = (tag) => {
    if (tag && !user.tags?.includes(tag)) {
      const updatedTags = [...(user.tags || []), tag];
      setUser({ ...user, tags: updatedTags });
      setNewTag("");
    }
    setShowTagInput(false);
  };

  // Función para manejar la adición de un nuevo email
  const handleAddEmail = () => {
    if (newEmail && !user.emails.includes(newEmail)) {
      const updatedEmails = [...(user.emails || []), newEmail];
      setUser({
        ...user,
        emails: updatedEmails,
        // Opcional: mantener el primer email como el principal
        email: user.email || newEmail,
      });
      setNewEmail("");
    }
  };

  // Función para eliminar un email
  const handleRemoveEmail = (emailToRemove) => {
    const updatedEmails = user.emails.filter(
      (email) => email !== emailToRemove
    );
    setUser({
      ...user,
      emails: updatedEmails,
      // Si se elimina el email principal, actualizarlo
      email: user.email === emailToRemove ? updatedEmails[0] || "" : user.email,
    });
  };

  // Función para establecer como email principal

  return (
    <div
      className="relative h-full flex flex-col min-w-0 break-words w-full mb-6 rounded-lg border-0"
      style={{
        backgroundColor: "#ffffff",
        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
      }}
    >
      {/* Header */}
      <div
        className="rounded-t-lg mb-0 py-4 px-6 border-b border-gray-100"
        style={{
          backgroundColor: "#ffffff",
        }}
      >
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <div className="mr-4">
              <Typography
                variant="h5"
                className="font-semibold"
                style={{ color: "#1e293b" }}
              >
                {user.name}
              </Typography>
              <div className="flex items-center mt-1">
                <span
                  className="text-sm font-medium px-2 py-0.5 rounded-full mr-2"
                  style={{
                    backgroundColor: "#e0f2fe",
                    color: "#0369a1",
                    fontSize: "0.75rem",
                  }}
                >
                  {user.role || "Cliente"}
                </span>
                <Typography
                  variant="body2"
                  className="text-gray-500"
                  style={{ fontSize: "0.875rem" }}
                >
                  {user.email}
                </Typography>
              </div>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <Button
              variant="outlined"
              size="small"
              startIcon={
                <img
                  width={16}
                  src={`${config.files}/images/drive.png`}
                  alt="Google Drive"
                />
              }
              sx={{
                color: "#1e40af",
                borderColor: "#bfdbfe",
                textTransform: "none",
                fontWeight: 500,
                fontSize: "0.8125rem",
                "&:hover": {
                  borderColor: "#93c5fd",
                  backgroundColor: "#eff6ff",
                },
              }}
              disabled
            >
              Google Drive
            </Button>
            <Button
              variant="contained"
              size="small"
              startIcon={<WhatsApp sx={{ fontSize: "1.1rem" }} />}
              onClick={() => sendWhatsApp(user.phone)}
              sx={{
                backgroundColor: "#22c55e",
                color: "white",
                textTransform: "none",
                fontWeight: 500,
                fontSize: "0.8125rem",
                "&:hover": {
                  backgroundColor: "#16a34a",
                },
                boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
              }}
            >
              WhatsApp
            </Button>
          </div>
        </div>
      </div>

      {/* Tabs */}
      <Box
        sx={{
          borderBottom: 1,
          borderColor: "divider",
          backgroundColor: "#ffffff",
        }}
      >
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            minHeight: "40px",
            backgroundColor: "#ffffff",
            "& .MuiTab-root": {
              color: "#64748b",
              textTransform: "none",
              minHeight: "40px",
              padding: "8px 16px",
              fontSize: "0.8rem",
              minWidth: "auto",
              "& .MuiSvgIcon-root": {
                fontSize: "1.1rem",
                marginBottom: "0 !important",
                marginRight: 6,
                color: "inherit",
              },
              "&.Mui-selected": {
                color: "#1e40af",
                fontWeight: 500,
                backgroundColor: "rgba(30, 64, 175, 0.05)",
              },
              "&:hover": {
                backgroundColor: "rgba(30, 64, 175, 0.03)",
                color: "#1e40af",
              },
            },
            "& .MuiTabs-indicator": {
              backgroundColor: "#1e40af",
              height: "2px",
            },
            "& .MuiTabs-scrollButtons": {
              width: 32,
              height: 40,
              color: "#1e40af",
              "&.Mui-disabled": {
                opacity: 0.3,
              },
            },
          }}
        >
          <Tab
            icon={<BusinessCenter />}
            iconPosition="start"
            label="Perfil"
            sx={{ minHeight: "40px", padding: "8px 16px" }}
          />
          <Tab
            icon={<Assessment />}
            iconPosition="start"
            label="Reportes"
            sx={{ minHeight: "40px", padding: "8px 16px" }}
          />
          <Tab
            icon={<Receipt />}
            iconPosition="start"
            label="Facturación"
            sx={{ minHeight: "40px", padding: "8px 16px" }}
          />
          <Tab
            icon={<People />}
            iconPosition="start"
            label="Trabajadores"
            sx={{ minHeight: "40px", padding: "8px 16px" }}
          />
          <Tab
            icon={<Language />}
            iconPosition="start"
            label="Portal de Cliente"
            sx={{ minHeight: "40px", padding: "8px 16px" }}
          />
        </Tabs>
      </Box>

      {/* Tab Content */}
      <div className="flex-auto px-4 py-4" style={{ backgroundColor: "#fff" }}>
        {/* Tab 0: Perfil del Usuario */}
        {activeTab === 0 && (
          <UserProfileTab
            user={user}
            setUser={setUser}
            handleSubmit={handleSubmit}
            newTag={newTag}
            setNewTag={setNewTag}
            handleAddTag={handleAddTag}
            showTagInput={showTagInput}
            setShowTagInput={setShowTagInput}
            predefinedTags={predefinedTags}
            memberships={memberships}
            newEmail={newEmail}
            setNewEmail={setNewEmail}
            handleAddEmail={handleAddEmail}
            handleRemoveEmail={handleRemoveEmail}
            users={users}
            handleMoveFolder={handleMoveFolder}
            handleInitDrive={handleInitDrive}
            loadUserData={loadUserData}
          />
        )}

        {/* Tab 1: Ver Reportes */}

        {/* Tab 2: Enviar Reporte */}
        {activeTab === 1 && <SendCampaignTab user={user} />}

        {/* Tab 3: Facturación */}
        {activeTab === 2 && <InvoicingTab invoices={invoices} />}

        {/* Tab 4: Liquidaciones */}

        {/* Tab 4: Trabajadores */}
        {activeTab === 3 && (
          <WorkersTab workers={workers} sendWhatsApp={sendWhatsApp} />
        )}

        {/* Tab 5: Portal de Cliente */}
        {activeTab === 4 && (
          <PortalClienteTab memberId={user._id} memberEmail={user.email} memberEmails={user.emails} memberName={user.name} />
        )}
      </div>
    </div>
  );
}

// Componente para el tab de perfil de usuario

const fieldSx = {
  "& .MuiOutlinedInput-root": {
    backgroundColor: "#f9fafb",
    borderRadius: "0.5rem",
    "&:hover fieldset": { borderColor: "#cbd5e1" },
    "&.Mui-focused fieldset": { borderColor: "#3b82f6" },
  },
  "& .MuiInputBase-input": { padding: "10px 14px", color: "#111827", fontSize: "0.875rem" },
};

const SectionCard = ({ title, icon, children, action }) => (
  <Box sx={{ border: "1px solid #e2e8f0", borderRadius: 3, backgroundColor: "#fff", mb: 3, overflow: "hidden" }}>
    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", px: 3, py: 2, borderBottom: "1px solid #f1f5f9", backgroundColor: "#f8fafc" }}>
      <Typography variant="subtitle2" sx={{ fontWeight: 600, color: "#1e293b", display: "flex", alignItems: "center", gap: 1, fontSize: "0.85rem" }}>
        {icon}
        {title}
      </Typography>
      {action}
    </Box>
    <Box sx={{ p: 3 }}>{children}</Box>
  </Box>
);

const FieldLabel = ({ children }) => (
  <label style={{ fontSize: "0.8rem", color: "#64748b", display: "block", marginBottom: 6, fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.03em" }}>
    {children}
  </label>
);

const UserProfileTab = ({
  user,
  setUser,
  handleSubmit,
  newTag,
  setNewTag,
  handleAddTag,
  showTagInput,
  setShowTagInput,
  predefinedTags,
  memberships,
  newEmail,
  setNewEmail,
  handleAddEmail,
  handleRemoveEmail,
  users = [],
  handleMoveFolder,
  handleInitDrive,
  loadUserData,
}) => (
  <div style={{ color: "#1f2937", maxWidth: 960 }}>

    {/* Ejecutivo Asignado */}
    <SectionCard title="Ejecutivo Asignado" icon={<BusinessCenter sx={{ fontSize: 18, color: "#64748b" }} />}>
      <Select
        fullWidth
        value={user.owner?._id || user.owner || ""}
        onChange={(e) => {
          const newOwnerId = e.target.value;
          const selectedUser = users.find((u) => u._id === newOwnerId);
          const previousOwner = user.owner;
          setUser({ ...user, owner: newOwnerId ? { _id: newOwnerId, name: selectedUser?.name, email: selectedUser?.email, gdriveFolderId: selectedUser?.gdriveFolderId } : null });
          if (user.driveFolders?.company && previousOwner?.gdriveFolderId && selectedUser?.gdriveFolderId && previousOwner._id !== newOwnerId) {
            if (window.confirm(`¿Desea mover la carpeta de Drive al ejecutivo ${selectedUser.name}?`)) {
              handleMoveFolder(user.driveFolders.company, previousOwner.gdriveFolderId, selectedUser.gdriveFolderId, user._id, newOwnerId);
            }
          }
        }}
        displayEmpty
        size="small"
        sx={{ borderRadius: "0.5rem", backgroundColor: "#f9fafb", fontSize: "0.875rem" }}
      >
        <MenuItem value="">Sin asignar</MenuItem>
        {users.filter((u) => u.gdriveFolderId).map((u) => (
          <MenuItem key={u._id} value={u._id}>{u.name} ({u.email})</MenuItem>
        ))}
      </Select>
    </SectionCard>

    {/* Google Drive */}
    <SectionCard title="Google Drive" icon={<img width={16} src="https://upload.wikimedia.org/wikipedia/commons/1/12/Google_Drive_icon_%282020%29.svg" alt="" style={{ opacity: 0.7 }} />}>
      {user && user.driveFolders?.company ? (
        <GoogleDriveFolders driveFolders={user.driveFolders} memberId={user._id} onFoldersChange={loadUserData} />
      ) : user.owner ? (
        <div style={{ border: "2px dashed #d1d5db", borderRadius: 12, padding: "2rem", textAlign: "center", backgroundColor: "#f9fafb" }}>
          <Google sx={{ fontSize: 40, color: "#9ca3af", mb: 1 }} />
          <p style={{ color: "#6b7280", marginBottom: "1rem", fontSize: "0.875rem" }}>Este cliente no tiene carpetas de Google Drive configuradas</p>
          <Button variant="contained" startIcon={<FolderPlus size={16} />} onClick={handleInitDrive} sx={{ backgroundColor: "#1e40af", textTransform: "none", borderRadius: 2, fontSize: "0.8rem", "&:hover": { backgroundColor: "#1e3a8a" } }}>
            Crear carpetas en Google Drive
          </Button>
        </div>
      ) : (
        <div style={{ border: "2px dashed #e5e7eb", borderRadius: 12, padding: "1.5rem", textAlign: "center", backgroundColor: "#fafafa" }}>
          <p style={{ color: "#9ca3af", fontSize: "0.85rem", margin: 0 }}>Asigne un ejecutivo para poder crear carpetas en Google Drive</p>
        </div>
      )}
    </SectionCard>

    {/* Información Personal */}
    <SectionCard title="Información Personal" icon={<People sx={{ fontSize: 18, color: "#64748b" }} />}>
      <form>
        <Grid container spacing={2.5}>
          <Grid item xs={12} md={6}>
            <FieldLabel>Nombre <span style={{ fontSize: "0.65rem", backgroundColor: "#dbeafe", color: "#1e40af", padding: "1px 6px", borderRadius: 4, fontWeight: 600, marginLeft: 4 }}>icontador*</span></FieldLabel>
            <TextField fullWidth value={user.name} onChange={(e) => setUser({ ...user, name: e.target.value })} sx={fieldSx} variant="outlined" />
          </Grid>
          <Grid item xs={12} md={6}>
            <FieldLabel>Razón Social</FieldLabel>
            <TextField fullWidth value={user.company_information?.razon_social || ""} onChange={(e) => setUser({ ...user, company_information: { ...user.company_information, razon_social: e.target.value } })} sx={fieldSx} variant="outlined" />
          </Grid>
          <Grid item xs={12} md={6}>
            <FieldLabel>RUT</FieldLabel>
            <TextField fullWidth value={user.id_number} onChange={(e) => setUser({ ...user, id_number: e.target.value })} sx={fieldSx} variant="outlined" />
          </Grid>
          <Grid item xs={12} md={6}>
            <FieldLabel>Teléfono</FieldLabel>
            <TextField fullWidth value={user.phone} onChange={(e) => setUser({ ...user, phone: e.target.value })} sx={fieldSx} variant="outlined" />
          </Grid>
          <Grid item xs={12} md={6}>
            <FieldLabel>Fecha de nacimiento</FieldLabel>
            <TextField fullWidth type="date" value={user.birthday} onChange={(e) => setUser({ ...user, birthday: e.target.value })} sx={fieldSx} variant="outlined" />
          </Grid>
          <Grid item xs={12} md={6}>
            <FieldLabel>Correo electrónico</FieldLabel>
            <TextField fullWidth value={user.email || ""} onChange={(e) => setUser({ ...user, email: e.target.value })} sx={fieldSx} variant="outlined" />
          </Grid>
          <Grid item xs={12} md={6}>
            <FieldLabel>Status</FieldLabel>
            <Select
              fullWidth
              value={user.enabled}
              onChange={(e) => setUser({ ...user, enabled: e.target.value })}
              size="small"
              displayEmpty
              sx={{ borderRadius: "0.5rem", backgroundColor: "#f9fafb", fontSize: "0.875rem", "& .MuiSelect-select": { padding: "10px 14px" } }}
            >
              <MenuItem value=""><em>Selecciona estado</em></MenuItem>
              <MenuItem value={true}>Activo</MenuItem>
              <MenuItem value={false}>Inactivo</MenuItem>
            </Select>
          </Grid>
        </Grid>

        {/* Correos adicionales */}
        <Box sx={{ mt: 3, p: 2, backgroundColor: "#f8fafc", borderRadius: 2, border: "1px solid #e2e8f0" }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 600, color: "#475569", mb: 1.5, fontSize: "0.8rem" }}>
            Correos adicionales
          </Typography>
          {user.emails?.filter((email) => email !== user.email).map((email, index) => (
            <Box key={index} display="flex" alignItems="center" mb={1} p={1} px={1.5} sx={{ backgroundColor: "#fff", borderRadius: 1.5, border: "1px solid #e5e7eb" }}>
              <Typography variant="body2" sx={{ flexGrow: 1, color: "#334155", fontSize: "0.85rem" }}>{email}</Typography>
              <Button size="small" onClick={() => { const currentEmail = user.email; const updatedEmails = user.emails.filter((e) => e !== email).concat(currentEmail ? [currentEmail] : []); setUser({ ...user, email: email, emails: updatedEmails }); }} sx={{ mr: 0.5, textTransform: "none", fontSize: "0.75rem", color: "#1e40af" }}>
                Usar como principal
              </Button>
              <IconButton size="small" onClick={() => { const updatedEmails = user.emails.filter((e) => e !== email); setUser({ ...user, emails: updatedEmails }); }} sx={{ color: "#94a3b8", "&:hover": { color: "#ef4444" } }}>
                <DeleteForever sx={{ fontSize: 18 }} />
              </IconButton>
            </Box>
          ))}
          <Box display="flex" gap={1} mt={1.5}>
            <TextField fullWidth size="small" placeholder="Agregar correo adicional" value={newEmail} onChange={(e) => setNewEmail(e.target.value)} onKeyPress={(e) => e.key === "Enter" && handleAddEmail()} sx={{ ...fieldSx, "& .MuiInputBase-input": { padding: "8px 12px", color: "#111827", fontSize: "0.85rem" } }} />
            <Button variant="outlined" size="small" onClick={() => { if (newEmail && !user.emails?.includes(newEmail)) { setUser({ ...user, emails: [...(user.emails || []), newEmail] }); setNewEmail(""); } }} disabled={!newEmail} sx={{ textTransform: "none", borderColor: "#cbd5e1", color: "#475569", fontSize: "0.8rem", whiteSpace: "nowrap" }}>
              Agregar
            </Button>
          </Box>
        </Box>
      </form>
    </SectionCard>

    {/* Suscripción */}
    <SectionCard title="Suscripción" icon={<Receipt sx={{ fontSize: 18, color: "#64748b" }} />}>
      <Grid container spacing={2.5}>
        <Grid item xs={12} md={6}>
          <FieldLabel>Plan Actual</FieldLabel>
          <Autocomplete
            options={memberships}
            value={memberships.find((m) => m._id === user.subscription?.membership) || null}
            onChange={(_, value) => { setUser((prev) => ({ ...prev, subscription: { ...prev.subscription, membership: value?._id || null, type: value?.title || "" } })); }}
            getOptionLabel={(option) => option.title || ""}
            renderInput={(params) => (
              <TextField {...params} variant="outlined" size="small" placeholder="Seleccionar plan" sx={fieldSx} />
            )}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FieldLabel>Fecha de inscripción</FieldLabel>
          <TextField fullWidth type="date" value={user.subscription?.startDate} onChange={(e) => setUser({ ...user, subscription: { ...user.subscription, startDate: e.target.value } })} sx={fieldSx} variant="outlined" />
        </Grid>
        <Grid item xs={12} md={6}>
          <FieldLabel>Fecha de vencimiento</FieldLabel>
          <TextField
            fullWidth type="date"
            value={user.subscription?.endDate ? new Date(user.subscription.endDate).toISOString().split("T")[0] : ""}
            onChange={(e) => { setUser((prev) => ({ ...prev, subscription: { ...prev.subscription, endDate: e.target.value } })); }}
            inputProps={{ min: user.subscription?.startDate || new Date().toISOString().split("T")[0] }}
            error={user.subscription?.endDate && new Date(user.subscription.endDate) < new Date(user.subscription?.startDate || 0)}
            helperText={user.subscription?.endDate && new Date(user.subscription.endDate) < new Date(user.subscription?.startDate || 0) ? "La fecha de vencimiento debe ser posterior a la fecha de inicio" : ""}
            sx={fieldSx} variant="outlined"
          />
        </Grid>
      </Grid>
    </SectionCard>

    {/* Atributos Personalizados */}
    <SectionCard
      title="Atributos Personalizados"
      icon={<TuneOutlined sx={{ fontSize: 18, color: "#64748b" }} />}
      action={
        <Button variant="outlined" size="small" startIcon={<Add />} onClick={() => { setUser((prev) => ({ ...prev, attributes: [...(prev.attributes || []), { key: "", value: "" }] })); }} sx={{ borderColor: "#cbd5e1", color: "#475569", textTransform: "none", fontSize: "0.75rem", "&:hover": { borderColor: "#94a3b8", backgroundColor: "rgba(203, 213, 225, 0.1)" } }}>
          Agregar
        </Button>
      }
    >
      {!user.attributes || user.attributes.length === 0 ? (
        <Box sx={{ py: 3, textAlign: "center", backgroundColor: "#f8fafc", borderRadius: 2, border: "1px dashed #e2e8f0" }}>
          <Typography variant="body2" sx={{ color: "#94a3b8", fontSize: "0.85rem" }}>No hay atributos personalizados</Typography>
        </Box>
      ) : (
        <Box sx={{ backgroundColor: "#f8fafc", borderRadius: 2, border: "1px solid #e2e8f0", overflow: "hidden" }}>
          <Box sx={{ display: "grid", gridTemplateColumns: "1fr 2fr 40px", gap: 1, px: 2, py: 1.5, borderBottom: "1px solid #e2e8f0" }}>
            <Typography variant="caption" sx={{ fontWeight: 700, color: "#64748b", textTransform: "uppercase", fontSize: "0.7rem" }}>Clave</Typography>
            <Typography variant="caption" sx={{ fontWeight: 700, color: "#64748b", textTransform: "uppercase", fontSize: "0.7rem" }}>Valor</Typography>
            <div></div>
          </Box>
          {user.attributes?.map((attr, index) => (
            <Box key={index} sx={{ display: "grid", gridTemplateColumns: "1fr 2fr 40px", gap: 1, p: 2, alignItems: "center", borderBottom: "1px solid #f1f5f9", backgroundColor: "#fff", "&:hover": { backgroundColor: "#f8fafc" } }}>
              <TextField size="small" placeholder="Nombre" value={attr.key || ""} onChange={(e) => { const a = [...user.attributes]; a[index] = { ...a[index], key: e.target.value }; setUser({ ...user, attributes: a }); }} sx={{ "& .MuiOutlinedInput-root": { fontSize: "0.85rem", "&:hover fieldset": { borderColor: "#cbd5e1" } } }} />
              <TextField size="small" placeholder="Valor" value={attr.value || ""} onChange={(e) => { const a = [...user.attributes]; a[index] = { ...a[index], value: e.target.value }; setUser({ ...user, attributes: a }); }} sx={{ "& .MuiOutlinedInput-root": { fontSize: "0.85rem", "&:hover fieldset": { borderColor: "#cbd5e1" } } }} />
              <IconButton size="small" onClick={() => { const a = [...user.attributes]; a.splice(index, 1); setUser({ ...user, attributes: a }); }} sx={{ color: "#94a3b8", "&:hover": { color: "#ef4444", backgroundColor: "rgba(239, 68, 68, 0.08)" } }}>
                <DeleteOutline sx={{ fontSize: 18 }} />
              </IconButton>
            </Box>
          ))}
        </Box>
      )}
    </SectionCard>

    {/* Etiquetas */}
    <SectionCard
      title="Etiquetas"
      icon={<Assessment sx={{ fontSize: 18, color: "#64748b" }} />}
      action={
        !showTagInput && (
          <Button variant="outlined" size="small" startIcon={<Add />} onClick={() => setShowTagInput(true)} sx={{ borderColor: "#cbd5e1", color: "#475569", textTransform: "none", fontSize: "0.75rem", "&:hover": { borderColor: "#94a3b8", backgroundColor: "rgba(203, 213, 225, 0.1)" } }}>
            Agregar
          </Button>
        )
      }
    >
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: showTagInput ? 2 : 0 }}>
        {user.tags?.map((tag, index) => (
          <Chip key={index} label={tag} onDelete={() => { const t = [...user.tags]; t.splice(index, 1); setUser({ ...user, tags: t }); }} sx={{ backgroundColor: "#e0f2fe", color: "#0369a1", fontWeight: 500, fontSize: "0.8rem", "& .MuiChip-deleteIcon": { color: "#0369a1", "&:hover": { color: "#075985" } } }} />
        ))}
        {(!user.tags || user.tags.length === 0) && !showTagInput && (
          <Typography variant="body2" sx={{ color: "#94a3b8", fontSize: "0.85rem" }}>Sin etiquetas</Typography>
        )}
      </Box>

      {showTagInput && (
        <Box sx={{ display: "flex", gap: 1, flexDirection: "column" }}>
          <Box sx={{ display: "flex", gap: 1 }}>
            <Autocomplete freeSolo options={predefinedTags} value={newTag} onChange={(_, newValue) => { if (newValue) handleAddTag(newValue); }} renderInput={(params) => (
              <TextField {...params} size="small" placeholder="Selecciona o escribe una etiqueta" autoFocus value={newTag} onChange={(e) => setNewTag(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter" && newTag.trim()) { e.preventDefault(); handleAddTag(newTag.trim()); } }} sx={{ flex: 1, width: "300px" }} />
            )} sx={{ flex: 1, width: "100%" }} />
            <Button variant="contained" size="small" onClick={() => { if (newTag.trim()) handleAddTag(newTag.trim()); }} disabled={!newTag.trim()} sx={{ textTransform: "none", backgroundColor: "#1e40af", "&:hover": { backgroundColor: "#1e3a8a" } }}>Agregar</Button>
            <Button variant="outlined" size="small" onClick={() => { setShowTagInput(false); setNewTag(""); }} sx={{ textTransform: "none", borderColor: "#cbd5e1", color: "#475569" }}>Cancelar</Button>
          </Box>
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, mt: 1 }}>
            {predefinedTags.filter((tag) => !user.tags?.includes(tag)).map((tag) => (
              <Chip key={tag} label={tag} size="small" onClick={() => handleAddTag(tag)} sx={{ cursor: "pointer", fontSize: "0.75rem", "&:hover": { backgroundColor: "#e0f2fe" } }} />
            ))}
          </Box>
        </Box>
      )}
    </SectionCard>

    {/* Guardar */}
    <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1, mb: 2 }}>
      <Button
        variant="contained"
        size="large"
        onClick={handleSubmit}
        sx={{
          backgroundColor: "#1e40af",
          textTransform: "none",
          fontWeight: 600,
          fontSize: "0.875rem",
          px: 5,
          py: 1.2,
          borderRadius: 2,
          boxShadow: "0 1px 3px rgba(30, 64, 175, 0.3)",
          "&:hover": { backgroundColor: "#1e3a8a" },
        }}
      >
        Actualizar Información
      </Button>
    </Box>
  </div>
);

// Componente para el tab Portal de Cliente
const PortalClienteTab = ({ memberId, memberEmail, memberName, memberEmails }) => {
  const layout = useLayout();
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [inviting, setInviting] = useState(false);
  const [toggling, setToggling] = useState(false);

  useEffect(() => {
    if (!memberId) return;
    PortalService.getPortalStatus(memberId)
      .then(setStatus)
      .catch(() => setStatus(null))
      .finally(() => setLoading(false));
  }, [memberId]);

  const handleInvite = async () => {
    setInviting(true);
    try {
      const res = await PortalService.inviteMember(memberId);
      layout.successAlert({ message: res.message });
      const updated = await PortalService.getPortalStatus(memberId);
      setStatus(updated);
    } catch (err) {
      const msg = err?.response?.data?.error || "Error al enviar invitación";
      layout.errorAlert({ message: msg });
    } finally {
      setInviting(false);
    }
  };

  const handleToggle = async () => {
    setToggling(true);
    try {
      const res = await PortalService.togglePortalAccess(memberId);
      setStatus((prev) => ({ ...prev, portalEnabled: res.portalEnabled }));
      layout.successAlert({ message: res.message });
    } catch (err) {
      layout.errorAlert({ message: "Error al cambiar acceso" });
    } finally {
      setToggling(false);
    }
  };

  const StatusDot = ({ active }) => (
    <span
      style={{
        width: 8,
        height: 8,
        borderRadius: "50%",
        backgroundColor: active ? "#22c55e" : "#d1d5db",
        display: "inline-block",
        marginRight: 8,
      }}
    />
  );

  if (loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", padding: "3rem 0" }}>
        <MiniSpinner />
      </div>
    );
  }

  const allEmails = memberEmails && memberEmails.length > 0 ? memberEmails : memberEmail ? [memberEmail] : [];
  const users = status?.users || [];
  const hasAnyUser = users.length > 0;

  return (
    <div style={{ maxWidth: 800 }}>
      {/* Header */}
      <div style={{ marginBottom: 24 }}>
        <Typography variant="h6" sx={{ fontWeight: 700, color: "#0f172a", fontSize: "1.15rem" }}>
          Portal de Cliente
        </Typography>
        <Typography variant="body2" sx={{ color: "#64748b", mt: 0.5 }}>
          Gestiona el acceso de {memberName || "este cliente"} al portal
        </Typography>
      </div>

      {/* Estado general + toggle */}
      <Card
        sx={{
          border: "1px solid #e2e8f0",
          boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
          borderRadius: 3,
          mb: 3,
          overflow: "visible",
        }}
      >
        <CardContent sx={{ p: 3 }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 20 }}>
            <Typography variant="subtitle2" sx={{ fontWeight: 600, color: "#334155", fontSize: "0.9rem" }}>
              Acceso al Portal
            </Typography>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <Chip
                label={status?.portalEnabled ? "Habilitado" : "Deshabilitado"}
                size="small"
                sx={{
                  backgroundColor: status?.portalEnabled ? "#ecfdf5" : "#f1f5f9",
                  color: status?.portalEnabled ? "#059669" : "#64748b",
                  fontWeight: 700,
                  fontSize: "0.75rem",
                }}
              />
              <FormControlLabel
                control={
                  <Switch
                    checked={!!status?.portalEnabled}
                    onChange={handleToggle}
                    disabled={toggling}
                    size="small"
                    sx={{
                      "& .MuiSwitch-switchBase.Mui-checked": { color: "#1e40af" },
                      "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": { backgroundColor: "#1e40af" },
                    }}
                  />
                }
                label=""
                sx={{ m: 0 }}
              />
            </div>
          </div>

          {/* Emails registrados */}
          <Typography variant="subtitle2" sx={{ fontWeight: 600, color: "#334155", fontSize: "0.85rem", mb: 1.5 }}>
            Emails de la empresa ({allEmails.length})
          </Typography>
          <div style={{ display: "flex", flexDirection: "column", gap: 8, marginBottom: 20 }}>
            {allEmails.map((email) => {
              const user = users.find((u) => u.email === email);
              return (
                <div key={email} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 14px", backgroundColor: "#f8fafc", borderRadius: 8 }}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <StatusDot active={!!user?.emailVerified} />
                    <span style={{ fontSize: "0.85rem", color: "#334155", fontWeight: 500 }}>{email}</span>
                  </div>
                  <Chip
                    label={!user ? "Sin cuenta" : !user.emailVerified ? "Pendiente verificación" : "Activo"}
                    size="small"
                    sx={{
                      backgroundColor: !user ? "#f1f5f9" : !user.emailVerified ? "#fef3c7" : "#ecfdf5",
                      color: !user ? "#64748b" : !user.emailVerified ? "#92400e" : "#059669",
                      fontWeight: 600,
                      fontSize: "0.7rem",
                    }}
                  />
                </div>
              );
            })}
          </div>

          {/* Usuarios registrados */}
          {hasAnyUser && (
            <>
              <Typography variant="subtitle2" sx={{ fontWeight: 600, color: "#334155", fontSize: "0.85rem", mb: 1.5 }}>
                Usuarios registrados ({users.length})
              </Typography>
              <TableContainer sx={{ border: "1px solid #e2e8f0", borderRadius: 2, overflow: "hidden" }}>
                <Table size="small">
                  <TableHead>
                    <TableRow sx={{ backgroundColor: "#f8fafc" }}>
                      <TableCell sx={{ fontWeight: 700, fontSize: "0.75rem", color: "#64748b" }}>Email</TableCell>
                      <TableCell sx={{ fontWeight: 700, fontSize: "0.75rem", color: "#64748b" }}>Verificado</TableCell>
                      <TableCell sx={{ fontWeight: 700, fontSize: "0.75rem", color: "#64748b" }}>Último acceso</TableCell>
                      <TableCell sx={{ fontWeight: 700, fontSize: "0.75rem", color: "#64748b" }}>Registro</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {users.map((u) => (
                      <TableRow key={u._id}>
                        <TableCell sx={{ fontSize: "0.8rem", color: "#334155" }}>{u.email}</TableCell>
                        <TableCell>
                          <Chip
                            label={u.emailVerified ? "Sí" : "No"}
                            size="small"
                            sx={{
                              backgroundColor: u.emailVerified ? "#ecfdf5" : "#fef3c7",
                              color: u.emailVerified ? "#059669" : "#92400e",
                              fontWeight: 600,
                              fontSize: "0.7rem",
                            }}
                          />
                        </TableCell>
                        <TableCell sx={{ fontSize: "0.8rem", color: "#64748b" }}>
                          {u.lastLogin ? new Date(u.lastLogin).toLocaleDateString("es-CL") : "Nunca"}
                        </TableCell>
                        <TableCell sx={{ fontSize: "0.8rem", color: "#64748b" }}>
                          {new Date(u.createdAt).toLocaleDateString("es-CL")}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </>
          )}
        </CardContent>
      </Card>

      {/* Invitación */}
      {allEmails.length > 0 && (
        <Card
          sx={{
            border: "2px dashed #bfdbfe",
            boxShadow: "none",
            borderRadius: 3,
            backgroundColor: "#eff6ff",
          }}
        >
          <CardContent sx={{ p: 3, textAlign: "center" }}>
            <Send sx={{ fontSize: 36, color: "#3b82f6", mb: 1.5 }} />
            <Typography variant="subtitle1" sx={{ fontWeight: 600, color: "#1e293b", mb: 0.5 }}>
              Invitar al portal
            </Typography>
            <Typography variant="body2" sx={{ color: "#64748b", mb: 2.5, maxWidth: 400, mx: "auto" }}>
              Se enviará un correo a <strong>{allEmails.join(", ")}</strong> con un enlace para registrarse en el portal.
            </Typography>
            <Button
              variant="contained"
              startIcon={<Send sx={{ fontSize: "1rem" }} />}
              onClick={handleInvite}
              disabled={inviting}
              sx={{
                backgroundColor: "#1e40af",
                textTransform: "none",
                fontWeight: 600,
                fontSize: "0.875rem",
                px: 4,
                py: 1,
                borderRadius: 2,
                "&:hover": { backgroundColor: "#1e3a8a" },
              }}
            >
              {inviting ? "Enviando invitación..." : "Enviar Invitación"}
            </Button>
          </CardContent>
        </Card>
      )}

      {/* Info si no tiene email */}
      {allEmails.length === 0 && (
        <Card
          sx={{
            border: "2px dashed #fde68a",
            boxShadow: "none",
            borderRadius: 3,
            backgroundColor: "#fffbeb",
          }}
        >
          <CardContent sx={{ p: 3, textAlign: "center" }}>
            <Email sx={{ fontSize: 36, color: "#d97706", mb: 1.5 }} />
            <Typography variant="subtitle1" sx={{ fontWeight: 600, color: "#1e293b", mb: 0.5 }}>
              Email requerido
            </Typography>
            <Typography variant="body2" sx={{ color: "#64748b" }}>
              Configura un email en la pestaña de Perfil para poder enviar la invitación al portal.
            </Typography>
          </CardContent>
        </Card>
      )}
    </div>
  );
};

// Componente para facturación
const InvoicingTab = ({ invoices }) => (
  <div>
    <div className="flex justify-between items-center mb-4">
      <Typography variant="h6" sx={{ fontWeight: 700, color: "#0f172a", fontSize: "1.15rem" }}>
        Facturación
      </Typography>
      <Button
        variant="contained"
        size="small"
        startIcon={<Add />}
        sx={{ backgroundColor: "#1e40af", textTransform: "none", fontWeight: 600, fontSize: "0.8rem", borderRadius: 2, "&:hover": { backgroundColor: "#1e3a8a" } }}
      >
        Nueva Factura
      </Button>
    </div>

    <TableContainer sx={{ border: "1px solid #e2e8f0", borderRadius: 3, overflow: "hidden" }}>
      <Table>
        <TableHead>
          <TableRow sx={{ backgroundColor: "#f8fafc" }}>
            <TableCell sx={{ fontWeight: 600, color: "#475569", fontSize: "0.8rem" }}>N° Factura</TableCell>
            <TableCell sx={{ fontWeight: 600, color: "#475569", fontSize: "0.8rem" }}>Cliente</TableCell>
            <TableCell sx={{ fontWeight: 600, color: "#475569", fontSize: "0.8rem" }}>Monto</TableCell>
            <TableCell sx={{ fontWeight: 600, color: "#475569", fontSize: "0.8rem" }}>Fecha</TableCell>
            <TableCell sx={{ fontWeight: 600, color: "#475569", fontSize: "0.8rem" }}>Estado</TableCell>
            <TableCell sx={{ fontWeight: 600, color: "#475569", fontSize: "0.8rem" }}>Acciones</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {invoices.length === 0 && (
            <TableRow>
              <TableCell colSpan={6} sx={{ textAlign: "center", py: 4, color: "#94a3b8", fontSize: "0.85rem" }}>
                No hay facturas registradas
              </TableCell>
            </TableRow>
          )}
          {invoices.map((invoice) => (
            <TableRow key={invoice.id} sx={{ "&:hover": { backgroundColor: "#f8fafc" } }}>
              <TableCell sx={{ color: "#1e293b", fontSize: "0.85rem" }}>{invoice.number}</TableCell>
              <TableCell sx={{ color: "#475569", fontSize: "0.85rem" }}>{invoice.client}</TableCell>
              <TableCell sx={{ color: "#1e293b", fontSize: "0.85rem", fontWeight: 600 }}>
                ${invoice.amount.toLocaleString()}
              </TableCell>
              <TableCell sx={{ color: "#475569", fontSize: "0.85rem" }}>{invoice.date}</TableCell>
              <TableCell>
                <Chip label={invoice.status} color={getStatusColor(invoice.status)} size="small" sx={{ fontWeight: 600, fontSize: "0.75rem" }} />
              </TableCell>
              <TableCell>
                <IconButton size="small" sx={{ color: "#3b82f6", "&:hover": { backgroundColor: "rgba(59, 130, 246, 0.08)" } }}>
                  <Visibility sx={{ fontSize: 18 }} />
                </IconButton>
                <IconButton size="small" sx={{ color: "#3b82f6", "&:hover": { backgroundColor: "rgba(59, 130, 246, 0.08)" } }}>
                  <Download size={18} />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  </div>
);

// Componente para liquidaciones

// Componente para trabajadores
const WorkersTab = ({ workers, sendWhatsApp }) => (
  <div>
    <div className="flex justify-between items-center mb-6">
      <Typography
        variant="h5"
        className="font-bold"
        style={{ color: "#111827" }}
      >
        Trabajadores
      </Typography>
      <Button
        variant="contained"
        startIcon={<PersonAdd />}
        sx={{
          backgroundColor: "#1e40af",
          color: "white",
          textTransform: "none",
          "&:hover": {
            backgroundColor: "#1e3a8a",
          },
          boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
        }}
      >
        Agregar Trabajador
      </Button>
    </div>

    <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow sx={{ backgroundColor: "#f9fafb" }}>
              <TableCell sx={{ fontWeight: 600, color: "#374151" }}>
                Nombre
              </TableCell>
              <TableCell sx={{ fontWeight: 600, color: "#374151" }}>
                Cargo
              </TableCell>
              <TableCell sx={{ fontWeight: 600, color: "#374151" }}>
                Contacto
              </TableCell>
              <TableCell sx={{ fontWeight: 600, color: "#374151" }}>
                Acciones
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {workers.map((worker, index) => (
              <TableRow
                key={index}
                sx={{
                  "&:nth-of-type(odd)": { backgroundColor: "#f9fafb" },
                  "&:hover": { backgroundColor: "#f3f4f6" },
                }}
              >
                <TableCell sx={{ color: "#1f2937" }}>{worker.name}</TableCell>
                <TableCell sx={{ color: "#4b5563" }}>{worker.role}</TableCell>
                <TableCell sx={{ color: "#4b5563" }}>
                  {worker.phone || worker.email}
                </TableCell>
                <TableCell>
                  <IconButton
                    size="small"
                    onClick={() => sendWhatsApp(worker.phone)}
                    sx={{
                      color: "#22c55e",
                      "&:hover": {
                        backgroundColor: "rgba(34, 197, 94, 0.1)",
                      },
                    }}
                  >
                    <WhatsApp fontSize="small" />
                  </IconButton>
                  <IconButton
                    size="small"
                    sx={{
                      color: "#3b82f6",
                      "&:hover": {
                        backgroundColor: "rgba(59, 130, 246, 0.1)",
                      },
                    }}
                  >
                    <Edit fontSize="small" />
                  </IconButton>
                  <IconButton
                    size="small"
                    sx={{
                      color: "#ef4444",
                      "&:hover": {
                        backgroundColor: "rgba(239, 68, 68, 0.1)",
                      },
                    }}
                  >
                    <Delete fontSize="small" />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  </div>
);

// Componente para tarjetas de transacciones (mantenido igual)
export const TxCard = ({ title, timestamp, points }) => {
  return (
    <div
      className="my-3 px-4 py-4 gap-4 rounded-lg tx-card flex"
      style={{ backgroundColor: "rgba(31, 41, 55, 0.5)" }}
    >
      <img src={medal} alt="..." style={{ width: 60 }} />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <p className="font-semibold text-white">{title}</p>
        <p className="font-light text-xs mt-1 text-white">
          {new Date(timestamp).toLocaleDateString()} -{" "}
          {new Date(timestamp).toLocaleTimeString()}
        </p>
      </div>
      <div className="ml-auto flex flex-col items-center justify-center">
        <p className="font-bold" style={{ color: "#15803d" }}>
          +{points}
        </p>
        <p className="font-light text-xs text-white">Puntos</p>
      </div>
    </div>
  );
};

// Función auxiliar para colores de estado
const getStatusColor = (status) => {
  switch (status.toLowerCase()) {
    case "pagada":
    case "enviado":
    case "activo":
      return "success";
    case "pendiente":
    case "revisión":
      return "warning";
    case "vencida":
    case "inactivo":
      return "error";
    default:
      return "default";
  }
};

const GoogleDriveFolders = ({ driveFolders, memberId, onFoldersChange }) => {
  const [hoveredItem, setHoveredItem] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [currentPath, setCurrentPath] = useState([]);
  const [currentFiles, setCurrentFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filesError, setFilesError] = useState(null);
  const [viewMode, setViewMode] = useState("grid"); // 'grid' or 'list'
  const fileInputRef = React.useRef(null);

  // Modal nueva carpeta
  const [folderModalOpen, setFolderModalOpen] = useState(false);
  const [creatingFolder, setCreatingFolder] = useState(false);

  // Upload queue (subidas concurrentes con progress + retry)
  const [uploads, setUploads] = useState([]);
  const queueRef = React.useRef(null);
  if (!queueRef.current) {
    queueRef.current = createUploadQueue({
      concurrency: 3,
      maxRetries: 2,
      onItemUpdate: (item) => {
        setUploads((prev) => {
          const idx = prev.findIndex((p) => p.id === item.id);
          if (idx === -1) return [...prev, item];
          const copy = [...prev];
          copy[idx] = item;
          return copy;
        });
      },
    });
  }
  const uploadsActive = uploads.some((u) => u.status === "uploading" || u.status === "queued");

  // Menú contextual (rename / delete / copy link)
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [menuItem, setMenuItem] = useState(null);
  const [busyAction, setBusyAction] = useState(false);

  // Sincronización Drive
  const [syncing, setSyncing] = useState(false);
  const [syncMessage, setSyncMessage] = useState(null);
  // Cache de archivos pre-cargados por carpeta tras un sync deep.
  // Si está poblado, fetchFiles lo usa antes de pegarle a la API.
  const [filesByFolderCache, setFilesByFolderCache] = useState(null);

  const handleUpload = async (e) => {
    const files = e.target.files;
    if (!files || files.length === 0) return;

    const currentFolderId = currentPath.length > 0 ? currentPath[currentPath.length - 1].id : null;
    if (!currentFolderId) {
      alert("Navega a una carpeta antes de subir archivos");
      return;
    }

    const errors = [];
    for (const file of files) {
      const err = validateFile(file);
      if (err) {
        errors.push(err);
        continue;
      }
      queueRef.current.add(file, currentFolderId);
    }
    if (errors.length > 0) {
      alert(errors.join("\n"));
    }

    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  // Refrescar la carpeta actual cuando un upload termina exitosamente.
  useEffect(() => {
    const lastDone = uploads.find((u) => u.status === "done" && !u._refreshed);
    if (!lastDone) return;
    const currentFolderId = currentPath.length > 0 ? currentPath[currentPath.length - 1].id : null;
    if (currentFolderId) fetchFiles(currentFolderId);
    setUploads((prev) => prev.map((u) => (u.id === lastDone.id ? { ...u, _refreshed: true } : u)));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uploads]);

  const handleCreateFolderConfirm = async (name) => {
    setCreatingFolder(true);
    try {
      const response = await fetch(`${config.url}/gdrive/create-folder`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name,
          parentFolderId: driveFolders.company,
          memberId,
        }),
      });
      if (!response.ok) {
        const body = await response.json().catch(() => ({}));
        throw new Error(body.error || `HTTP ${response.status}`);
      }
      setFolderModalOpen(false);
      if (onFoldersChange) onFoldersChange();
    } catch (err) {
      alert(`No se pudo crear la carpeta: ${err.message}`);
    } finally {
      setCreatingFolder(false);
    }
  };

  // Acciones del menú contextual
  const openMenu = (anchor, item) => { setMenuAnchor(anchor); setMenuItem(item); };
  const closeMenu = () => { setMenuAnchor(null); setMenuItem(null); };

  const handleRename = async () => {
    if (!menuItem) return;
    const next = window.prompt("Nuevo nombre:", menuItem.name);
    if (!next || next.trim() === menuItem.name) { closeMenu(); return; }
    setBusyAction(true);
    try {
      await renameDriveFolderApi({ folderId: menuItem.id, name: next.trim(), memberId });
      if (onFoldersChange) onFoldersChange();
    } catch (err) {
      alert(`No se pudo renombrar: ${err.message}`);
    } finally {
      setBusyAction(false);
      closeMenu();
    }
  };

  const handleDelete = async () => {
    if (!menuItem) return;
    if (!window.confirm(`¿Mover "${menuItem.name}" a la papelera de Drive?`)) { closeMenu(); return; }
    setBusyAction(true);
    try {
      await deleteDriveFolderApi({ folderId: menuItem.id, memberId });
      if (onFoldersChange) onFoldersChange();
    } catch (err) {
      alert(`No se pudo eliminar: ${err.message}`);
    } finally {
      setBusyAction(false);
      closeMenu();
    }
  };

  const handleCopyLink = async () => {
    if (!menuItem) return;
    const url = menuItem.webViewLink || `https://drive.google.com/drive/folders/${menuItem.id}`;
    try {
      await navigator.clipboard.writeText(url);
    } catch {
      window.prompt("Copiar este enlace:", url);
    }
    closeMenu();
  };

  const handleSyncDrive = async () => {
    if (!memberId) return;
    setSyncing(true);
    setSyncMessage(null);
    try {
      const res = await syncMemberDriveApi(memberId);
      const fileCount = res.totalFiles ?? 0;
      setSyncMessage(
        `Escaneadas ${res.scanned} carpetas · ${fileCount} archivos · ${res.added} nuevas agregadas.`
      );
      // Guardar el mapa { folderId: [files] } para que la navegación use el cache.
      if (res.filesByFolder) setFilesByFolderCache(res.filesByFolder);
      // Refrescar carpeta actual si estamos viendo una.
      if (res.filesByFolder && currentPath.length > 0) {
        const curId = currentPath[currentPath.length - 1].id;
        if (curId && res.filesByFolder[curId]) {
          const formatted = res.filesByFolder[curId]
            .filter((f) => f.mimeType !== "application/vnd.google-apps.folder")
            .map((f) => ({ ...f, type: "file", size: "—", modifiedTime: "Hace 1 día", owner: "Tú" }));
          setCurrentFiles(formatted);
        }
      }
      if (res.added > 0 && onFoldersChange) onFoldersChange();
    } catch (err) {
      setSyncMessage(`Error: ${err.message}`);
    } finally {
      setSyncing(false);
      setTimeout(() => setSyncMessage(null), 5000);
    }
  };

  // Crear estructura jerárquica de carpetas
  const createFolderStructure = () => {
    return [
      // 1) ROOT: Liquidaciones
      {
        name: "Liquidaciones",
        id: driveFolders.liquidaciones,
        type: "folder",
        modifiedTime: "—",
        size: "—",
        owner: "Tú",
        category: "main",
        children: [
          {
            name: "Trabajadores",
            id: null,
            type: "folder",
            modifiedTime: "—",
            size: "—",
            owner: "Tú",
            category: "sub",
            children: (driveFolders.workers || []).map((worker) => {
              const children = Object.entries(worker)
                .filter(([key, value]) => /^year\d{4}$/.test(key) && value)
                .map(([key, value]) => ({ year: key.slice(4), id: value }))
                .sort((a, b) => Number(b.year) - Number(a.year))
                .map(({ year, id }) => ({
                  name: year,
                  id,
                  type: "folder",
                  modifiedTime: "—",
                  size: "—",
                  owner: "Tú",
                  category: "worker-year",
                  children: [],
                }));

              return {
                name: worker.id_number,
                id: worker.worker,
                type: "folder",
                modifiedTime: "—",
                size: "—",
                owner: "Tú",
                category: "worker",
                children,
              };
            }),
          },
        ],
      },

      // 2) ROOT: Cotizaciones
      {
        name: "Cotizaciones",
        id: driveFolders.cotizaciones,
        type: "folder",
        modifiedTime: "—",
        size: "—",
        owner: "Tú",
        category: "main",
        children: Object.entries(driveFolders.cotizaciones || {})
          .filter(([key, value]) => /^year\d{4}$/.test(key) && value)
          .map(([key, value]) => ({ year: key.slice(4), id: value }))
          .sort((a, b) => Number(b.year) - Number(a.year))
          .map(({ year, id }) => ({
            name: year,
            id,
            type: "folder",
            modifiedTime: "—",
            size: "—",
            owner: "Tú",
            category: "cotizacion-year",
            children: [],
          })),
      },

      // 3) Custom folders
      ...(driveFolders.folders || []).map((folder) => ({
        name: folder.name,
        id: folder.id,
        type: "folder",
        modifiedTime: "—",
        size: "—",
        owner: "Tú",
        category: "custom",
        children: [],
      })),
    ];
  };

  const folderStructure = useMemo(() => createFolderStructure(), [driveFolders]);

  // Obtener elementos actuales basado en la ruta
  const getCurrentItems = () => {
    if (currentPath.length === 0) {
      return folderStructure;
    }

    let current = folderStructure;
    for (let pathItem of currentPath) {
      const folder = current.find((item) => item.id === pathItem.id);
      if (folder && folder.children) {
        current = folder.children;
      }
    }
    return current || [];
  };

  // Obtener archivos de una carpeta. Si hay cache del último sync deep, lo usa.
  const fetchFiles = async (folderId) => {
    if (!folderId) return;

    // Cache hit del sync deep — ahorra una llamada a Drive.
    if (filesByFolderCache && filesByFolderCache[folderId]) {
      const cached = filesByFolderCache[folderId]
        .filter((f) => f.mimeType !== "application/vnd.google-apps.folder")
        .map((f) => ({ ...f, type: "file", size: "—", modifiedTime: "Hace 1 día", owner: "Tú" }));
      setCurrentFiles(cached);
      setFilesError(null);
      return;
    }

    setLoading(true);
    setFilesError(null);
    try {
      const files = await fetchFolderFiles(folderId);

      // Filtrar solo archivos (excluye carpetas)
      const onlyFiles = (files || []).filter(
        (file) => file.mimeType !== "application/vnd.google-apps.folder"
      );

      const formattedFiles = onlyFiles.map((file) => ({
        ...file,
        type: "file",
        size: "—",
        modifiedTime: "Hace 1 día",
        owner: "Tú",
      }));

      setCurrentFiles(formattedFiles);
    } catch (error) {
      setCurrentFiles([]);
      setFilesError(error.message || "No se pudieron cargar los archivos");
    } finally {
      setLoading(false);
    }
  };

  // Obtener icono según el tipo de archivo
  const getFileIcon = (fileName, mimeType) => {
    const extension = fileName?.split(".").pop()?.toLowerCase();
    const iconProps = { size: 48, className: "mx-auto mb-2" };

    if (mimeType?.startsWith("image/")) {
      return <Image {...iconProps} className="mx-auto mb-2 text-blue-500" />;
    } else if (mimeType?.startsWith("video/")) {
      return <Video {...iconProps} className="mx-auto mb-2 text-red-500" />;
    } else if (mimeType?.startsWith("audio/")) {
      return <Music {...iconProps} className="mx-auto mb-2 text-purple-500" />;
    } else if (extension === "pdf" || mimeType === "application/pdf") {
      return (
        <img
          src={pdfIcon}
          alt="PDF file"
          className="mx-auto mb-2 w-6 h-6 object-contain"
        />
      );
    } else if (["doc", "docx"].includes(extension)) {
      return <FileText {...iconProps} className="mx-auto mb-2 text-blue-600" />;
    } else if (["xls", "xlsx"].includes(extension)) {
      return (
        <FileText {...iconProps} className="mx-auto mb-2 text-green-600" />
      );
    } else {
      return <File {...iconProps} className="mx-auto mb-2 text-gray-500" />;
    }
  };

  const handleItemClick = (item) => {
    setSelectedItem(item);

    if (item.type === "folder") {
      // Nodos virtuales (id null) son agrupadores como "Trabajadores":
      // navegables si tienen children, sin fetch a Drive.
      if (!item.id && (!item.children || item.children.length === 0)) return;
      setCurrentPath([...currentPath, item]);
      setCurrentFiles([]);
      if (item.id) fetchFiles(item.id);
    } else if (item.type === "file") {
      if (item.webViewLink) window.open(item.webViewLink, "_blank");
    }
  };

  const navigateBack = () => {
    const newPath = [...currentPath];
    newPath.pop();
    setCurrentPath(newPath);

    if (newPath.length > 0) {
      fetchFiles(newPath[newPath.length - 1].id);
    } else {
      setCurrentFiles([]);
    }
  };

  const currentItems = getCurrentItems();
  const allItems = [...currentItems, ...currentFiles];

  useEffect(() => {
    if (currentPath.length > 0) {
      fetchFiles(currentPath[currentPath.length - 1].id);
    }
  }, [currentPath]);

  return (
    <div style={{ background: "#fff" }}>
      {/* Header */}
      <div style={{ borderBottom: "1px solid #e5e7eb", padding: "0.5rem" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
            {currentPath.length > 0 && (
              <button
                onClick={navigateBack}
                style={{ padding: 8, borderRadius: "50%", border: "none", background: "transparent", cursor: "pointer", display: "flex", alignItems: "center" }}
              >
                <ArrowLeft size={20} color="#4b5563" />
              </button>
            )}
            <h1 style={{ fontSize: "1.5rem", fontWeight: 400, color: "#1f2937", margin: 0 }}>
              {currentPath.length === 0
                ? "Mi unidad"
                : currentPath[currentPath.length - 1].name}
            </h1>
          </div>

          {/* Actions */}
          <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
            {/* Sync Drive button */}
            {memberId && driveFolders.company && (
              <button
                onClick={handleSyncDrive}
                disabled={syncing}
                title="Escanear Drive y agregar carpetas faltantes"
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 4,
                  padding: "6px 12px",
                  border: "1px solid #d1d5db",
                  borderRadius: 6,
                  fontSize: "0.8rem",
                  fontWeight: 500,
                  background: "#fff",
                  color: "#374151",
                  cursor: syncing ? "not-allowed" : "pointer",
                  opacity: syncing ? 0.6 : 1,
                }}
              >
                {syncing ? <MiniSpinner /> : <Autorenew style={{ fontSize: 16 }} />}
                Sincronizar Drive
              </button>
            )}

            {/* Create folder button */}
            {driveFolders.company && (
              <button
                onClick={() => setFolderModalOpen(true)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 4,
                  padding: "6px 12px",
                  border: "1px solid #d1d5db",
                  borderRadius: 6,
                  fontSize: "0.8rem",
                  fontWeight: 500,
                  background: "#fff",
                  color: "#374151",
                  cursor: "pointer",
                }}
              >
                <FolderPlus size={16} />
                Nueva carpeta
              </button>
            )}

            {/* Upload button - only when inside a folder with an ID */}
            {currentPath.length > 0 && currentPath[currentPath.length - 1].id && (
              <>
                <input
                  ref={fileInputRef}
                  type="file"
                  multiple
                  onChange={handleUpload}
                  style={{ display: "none" }}
                />
                <button
                  onClick={() => fileInputRef.current?.click()}
                  disabled={uploadsActive}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 4,
                    padding: "6px 14px",
                    border: "none",
                    borderRadius: 6,
                    fontSize: "0.8rem",
                    fontWeight: 600,
                    background: uploadsActive ? "#94a3b8" : "#0353a4",
                    color: "#fff",
                    cursor: uploadsActive ? "not-allowed" : "pointer",
                    opacity: uploadsActive ? 0.7 : 1,
                    boxShadow: "0 1px 4px rgba(3,83,164,0.25)",
                  }}
                >
                  {uploadsActive ? (
                    <MiniSpinner />
                  ) : (
                    <Upload size={16} />
                  )}
                  Subir archivo
                </button>
              </>
            )}

            {/* View Mode Toggle */}
            <button
              onClick={() => setViewMode("grid")}
              style={{
                padding: 8,
                borderRadius: 6,
                border: "none",
                background: viewMode === "grid" ? "#dbeafe" : "transparent",
                color: viewMode === "grid" ? "#2563eb" : "#6b7280",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
              }}
            >
              <Grid3X3 size={20} />
            </button>
            <button
              onClick={() => setViewMode("list")}
              style={{
                padding: 8,
                borderRadius: 6,
                border: "none",
                background: viewMode === "list" ? "#dbeafe" : "transparent",
                color: viewMode === "list" ? "#2563eb" : "#6b7280",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
              }}
            >
              <List size={20} />
            </button>
          </div>
        </div>

        {/* Breadcrumb */}
        {currentPath.length > 0 && (
          <div style={{ marginTop: "0.5rem", fontSize: "0.85rem", color: "#4b5563" }}>
            <span
              style={{ cursor: "pointer" }}
              onClick={() => {
                setCurrentPath([]);
                setCurrentFiles([]);
              }}
            >
              Mi unidad
            </span>
            {currentPath.map((pathItem, index) => (
              <span key={pathItem.id}>
                <span style={{ margin: "0 0.5rem" }}>&rsaquo;</span>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    const newPath = currentPath.slice(0, index + 1);
                    setCurrentPath(newPath);
                    fetchFiles(pathItem.id);
                  }}
                >
                  {pathItem.name}
                </span>
              </span>
            ))}
          </div>
        )}
      </div>

      {/* Sync feedback */}
      {syncMessage && (
        <div
          style={{
            margin: "8px 12px",
            padding: "8px 12px",
            background: syncMessage.startsWith("Error") ? "#fef2f2" : "#ecfdf5",
            border: "1px solid",
            borderColor: syncMessage.startsWith("Error") ? "#fecaca" : "#bbf7d0",
            color: syncMessage.startsWith("Error") ? "#991b1b" : "#065f46",
            borderRadius: 8,
            fontSize: 13,
          }}
        >
          {syncMessage}
        </div>
      )}

      {/* Uploads en curso */}
      {uploads.length > 0 && (
        <div style={{ margin: "8px 12px", padding: 12, background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 8 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
            <span style={{ fontSize: 12, fontWeight: 600, color: "#334155" }}>
              {uploadsActive ? "Subiendo archivos..." : "Subidas completadas"}
            </span>
            {!uploadsActive && (
              <button
                onClick={() => { queueRef.current.clearDone(); setUploads(queueRef.current.items()); }}
                style={{ background: "transparent", border: "none", color: "#64748b", cursor: "pointer", fontSize: 12 }}
              >
                Limpiar
              </button>
            )}
          </div>
          {uploads.map((u) => (
            <div key={u.id} style={{ marginBottom: 6 }}>
              <div style={{ display: "flex", justifyContent: "space-between", fontSize: 12, color: "#475569", marginBottom: 2 }}>
                <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: "70%" }}>
                  {u.file?.name}
                </span>
                <span style={{
                  color: u.status === "error" ? "#dc2626" : u.status === "done" ? "#059669" : "#0353a4",
                  fontWeight: 500,
                }}>
                  {u.status === "uploading" ? `${Math.round((u.progress || 0) * 100)}%`
                    : u.status === "queued" ? "En cola"
                    : u.status === "done" ? "Listo"
                    : u.status === "error" ? `Error: ${u.error}`
                    : ""}
                </span>
              </div>
              <LinearProgress
                variant="determinate"
                value={(u.progress || 0) * 100}
                color={u.status === "error" ? "error" : u.status === "done" ? "success" : "primary"}
              />
            </div>
          ))}
        </div>
      )}

      {/* Loading */}
      {loading && !filesError && (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "2rem 0" }}>
          <MiniSpinner />
        </div>
      )}

      {/* Error fetching files */}
      {filesError && (
        <div style={{ padding: "12px 16px" }}>
          <DriveErrorState
            message={filesError}
            onRetry={() => {
              const id = currentPath.length > 0 ? currentPath[currentPath.length - 1].id : null;
              if (id) fetchFiles(id);
            }}
          />
        </div>
      )}

      {/* Content */}
      <div className="p-4 px-1">
        {viewMode === "list" ? (
          /* List View */
          <div>
            {/* Toolbar for List */}
            <div className="border-b border-gray-200 pb-2 mb-4 flex items-center gap-2">
              <button className="px-3 py-2 text-sm text-gray-600 hover:bg-gray-100 rounded">
                Nombre
              </button>
              <button className="px-3 py-2 text-sm text-gray-600 hover:bg-gray-100 rounded">
                Propietario
              </button>
              <button className="px-3 py-2 text-sm text-gray-600 hover:bg-gray-100 rounded">
                Última modificación
              </button>
              <button className="px-3 py-2 text-sm text-gray-600 hover:bg-gray-100 rounded">
                Tamaño
              </button>
            </div>

            <div className="space-y-1">
              {allItems.map((item, index) => (
                <div
                  key={item.id || `file-${index}`}
                  className={`flex items-center p-2 rounded-lg cursor-pointer transition-colors duration-150 ${
                    hoveredItem === index
                      ? "bg-blue-50 border border-blue-200"
                      : selectedItem?.id === item.id
                      ? "bg-blue-100 border border-blue-300"
                      : "hover:bg-gray-50"
                  }`}
                  onMouseEnter={() => setHoveredItem(index)}
                  onMouseLeave={() => setHoveredItem(null)}
                  onClick={() => handleItemClick(item)}
                >
                  {/* Checkbox */}
                  <div className="w-8 flex justify-center">
                    <input
                      type="checkbox"
                      className="rounded border-gray-300"
                      onChange={(e) => e.stopPropagation()}
                    />
                  </div>

                  {/* Icon */}
                  <div className="w-8 flex justify-center mr-3">
                    {item.type === "folder" ? (
                      <Folder
                        size={20}
                        className={`${
                          hoveredItem === index || selectedItem?.id === item.id
                            ? item.category === "main"
                              ? "text-blue-600 fill-blue-100"
                              : item.category === "worker"
                              ? "text-green-600 fill-green-100"
                              : item.category === "custom"
                              ? "text-purple-600 fill-purple-100"
                              : "text-orange-600 fill-orange-100"
                            : item.category === "main"
                            ? "text-blue-500 fill-blue-50"
                            : item.category === "worker"
                            ? "text-green-500 fill-green-50"
                            : item.category === "custom"
                            ? "text-purple-500 fill-purple-50"
                            : "text-orange-500 fill-orange-50"
                        }`}
                      />
                    ) : (
                      <div className="w-5 h-5 flex items-center justify-center">
                        {getFileIcon(item.name, item.mimeType)}
                      </div>
                    )}
                  </div>

                  {/* Name */}
                  <div className="flex-1 min-w-0">
                    <span
                      className={`text-sm font-medium truncate ${
                        item.type === "folder"
                          ? item.category === "main"
                            ? "text-gray-900"
                            : item.category === "worker"
                            ? "text-green-800"
                            : item.category === "custom"
                            ? "text-purple-800"
                            : "text-orange-800"
                          : "text-gray-900"
                      }`}
                    >
                      {item.name}
                    </span>
                    {item.type === "folder" && item.category !== "main" && (
                      <div className="text-xs text-gray-500 truncate">
                        {item.category === "worker"
                          ? "Carpeta de Trabajador"
                          : item.category === "custom"
                          ? "Carpeta personalizada"
                          : "Carpeta Anual"}
                      </div>
                    )}
                  </div>

                  {/* Owner */}
                  <div className="w-24 hidden md:block mx-1">
                    <span className="text-sm text-gray-600">
                      {item.owner || "—"}
                    </span>
                  </div>

                  {/* Modified Time */}
                  <div className="w-32 hidden md:block mx-1">
                    <span className="text-sm text-gray-600">
                      {item.modifiedTime || item.modifiedDate || "—"}
                    </span>
                  </div>

                  {/* Size */}
                  <div className="w-24 hidden md:block mx-1">
                    <span className="text-sm text-gray-600">
                      {item.size || "—"}
                    </span>
                  </div>

                  {/* More Options */}
                  <div className="w-8 flex justify-center">
                    {item.type === "folder" && item.id && (
                      <button
                        className={`p-1 rounded hover:bg-gray-200 transition-opacity duration-150 ${
                          hoveredItem === index ? "opacity-100" : "opacity-0"
                        }`}
                        onClick={(e) => {
                          e.stopPropagation();
                          openMenu(e.currentTarget, item);
                        }}
                      >
                        <MoreVertical size={16} className="text-gray-600" />
                      </button>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          /* Grid View */
          <div className="flex flex-wrap gap-4">
            {allItems.map((item, index) => (
              <div
                key={item.id || `file-${index}`}
                className={`w-24 sm:w-28 md:w-32 p-3 rounded-lg cursor-pointer transition-all duration-150 ${
                  hoveredItem === index
                    ? "bg-blue-50 border-2 border-blue-200 shadow-md"
                    : selectedItem?.id === item.id
                    ? "bg-blue-100 border-2 border-blue-300 shadow-md"
                    : "hover:bg-gray-50 hover:shadow-sm border-2 border-transparent"
                }`}
                onMouseEnter={() => setHoveredItem(index)}
                onMouseLeave={() => setHoveredItem(null)}
                onClick={() => handleItemClick(item)}
              >
                {/* Icon */}
                <div className="text-center mb-2">
                  {item.type === "folder" ? (
                    <Folder
                      size={48}
                      className={`mx-auto ${
                        hoveredItem === index || selectedItem?.id === item.id
                          ? item.category === "main"
                            ? "text-blue-600 fill-blue-100"
                            : item.category === "worker"
                            ? "text-green-600 fill-green-100"
                            : "text-orange-600 fill-orange-100"
                          : item.category === "main"
                          ? "text-blue-500 fill-blue-50"
                          : item.category === "worker"
                          ? "text-green-500 fill-green-50"
                          : "text-orange-500 fill-orange-50"
                      }`}
                    />
                  ) : (
                    getFileIcon(item.name, item.mimeType)
                  )}
                </div>

                {/* Name */}
                <div className="text-center">
                  <span
                    className={`text-xs font-medium truncate block ${
                      item.type === "folder"
                        ? item.category === "main"
                          ? "text-gray-900"
                          : item.category === "worker"
                          ? "text-green-800"
                          : item.category === "custom"
                          ? "text-purple-800"
                          : "text-orange-800"
                        : "text-gray-900"
                    }`}
                    title={item.name}
                  >
                    {item.name}
                  </span>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Empty State */}
        {allItems.length === 0 && !loading && !filesError && (
          <div className="text-center py-12">
            <Folder size={64} className="text-gray-300 mx-auto mb-4" />
            <p className="text-gray-500">
              {currentPath.length === 0
                ? "No hay carpetas configuradas"
                : "Esta carpeta está vacía"}
            </p>
          </div>
        )}
      </div>

      <CreateFolderModal
        open={folderModalOpen}
        onClose={() => setFolderModalOpen(false)}
        onConfirm={handleCreateFolderConfirm}
        siblings={folderStructure}
        busy={creatingFolder}
      />

      <Menu
        anchorEl={menuAnchor}
        open={Boolean(menuAnchor)}
        onClose={busyAction ? undefined : closeMenu}
      >
        <MenuItem onClick={handleCopyLink}>Copiar enlace</MenuItem>
        <MenuItem onClick={handleRename} disabled={busyAction}>Renombrar</MenuItem>
        <MenuItem onClick={handleDelete} disabled={busyAction} sx={{ color: "error.main" }}>
          Mover a papelera
        </MenuItem>
      </Menu>
    </div>
  );
};

const SendCampaignTab = ({ user }) => {
  const [attachments, setAttachments] = useState([]);
  const [variables, setVariables] = useState({});
  const [body, setBody] = useState("");
  const [isHtml, setIsHtml] = useState(true);
  const [campaigns, setCampaigns] = useState([]);
  const [selected, setSelected] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");

  // Fetch campaigns from backend
  useEffect(() => {
    fetch(`${config.url}/marketing/list`, {
      headers: {
        Authorization: `Basic ${process.env.REACT_APP_BASIC_AUTH}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log("Campaigns fetched:", data);
        setCampaigns(data);

        if (data.length > 0) {
          let settlements_ = data.filter(
            (c) =>
              c.template_html === "settlements" ||
              c.template_html === "f29_mensualidad" ||
              c.template_html === "renta_at2026"
          );

          setCampaigns(settlements_);
          return;
        }
      });
  }, []);

  // Cambia campaña seleccionada
  const handleSelect = (camp) => {
    setSelected(camp);
    const baseVars = { ...(camp.configVariables || {}) };
    if (camp.template_html === "renta_at2026") {
      const toBool = (v) => v === true || v === "true";
      delete baseVars.nombre_empresa;
      if (baseVars.resultado === undefined) baseVars.resultado = "";
      if (baseVars.monto_resultado === undefined) baseVars.monto_resultado = "";
      baseVars.incluir_balance_general = toBool(baseVars.incluir_balance_general);
      baseVars.incluir_libro_mayor = toBool(baseVars.incluir_libro_mayor);
      baseVars.incluir_libro_diario = toBool(baseVars.incluir_libro_diario);
      baseVars.incluir_certificados = toBool(baseVars.incluir_certificados);
    }
    setVariables(baseVars);
    setBody(
      (camp.content?.body || "")
        .replace(/<br\s*\/?>/gi, "\n")
        .replace(/\\n/g, "\n")
    );
  };

  // Adjuntar archivo manual
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setAttachments((prev) => [
      ...prev,
      { filename: file.name, file, mimeType: file.type },
    ]);
  };

  // Actualizar valor de variable existente
  const handleUpdateVar = (key, value) => {
    setVariables((prev) => ({ ...prev, [key]: value }));
  };

  // Enviar campaña
  const handleSend = async () => {
    if (!selected) return;
    if (!user?._id) {
      alert("Error: no se pudo identificar al cliente. Recarga la página.");
      return;
    }
    const formData = new FormData();
    formData.append("campaignId", selected._id);

    formData.append(
      "recipients",
      JSON.stringify([{ type: "email", value: user.email }])
    );
    formData.append(
      "content",
      JSON.stringify({
        body: body || selected.content?.body || "",
      })
    );
    formData.append("configVariables", JSON.stringify(variables));
    attachments.forEach((att, i) => {
      if (att.file) formData.append("attachments", att.file);
      formData.append(`attachmentsInfo[${i}][filename]`, att.filename);
      formData.append(`attachmentsInfo[${i}][mimeType]`, att.mimeType);
    });

    console.log(formData);

    await fetch(`${config.url}/marketing/send/${user._id}`, {
      method: "POST",
      body: formData,
      headers: {
        Authorization: `Basic ${process.env.REACT_APP_BASIC_AUTH}`,
      },
    });
    alert("Campaña enviada");
  };

  return (
    <Box sx={{ display: "flex", gap: 1, p: 0 }}>
      {/* Panel izquierdo: Selección de campaña */}
      <Paper
        elevation={1}
        sx={{
          flex: 1,
          minWidth: 320,
          maxWidth: 420,
          p: 2,
          background: "rgba(255, 255, 255, 0.95)",
          backdropFilter: "blur(10px)",
          borderRadius: 2,
        }}
      >
        <Typography
          variant="h6"
          sx={{
            mb: 2,
            fontWeight: 600,
            color: "#1e293b",
            fontSize: "1.1rem",
          }}
        >
          Seleccionar Campaña
        </Typography>

        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
          {campaigns &&
            campaigns.length > 0 &&
            campaigns.map((c) => {
              const isSelected = selected?._id === c._id;
              return (
                <Card
                  key={c._id}
                  onClick={() => handleSelect(c)}
                  sx={{
                    cursor: "pointer",
                    border: isSelected
                      ? "2px solid #3b82f6"
                      : "1px solid #e2e8f0",
                    background: isSelected ? "#f8fafc" : "#fff",
                    boxShadow: isSelected
                      ? "0 4px 12px rgba(59, 130, 246, 0.15)"
                      : "0 1px 3px rgba(0, 0, 0, 0.1)",
                    transition: "all 0.2s ease",
                    "&:hover": {
                      boxShadow: "0 4px 12px rgba(59, 130, 246, 0.2)",
                      transform: "translateY(-1px)",
                      border: "2px solid #3b82f6",
                    },
                    padding: 0,
                  }}
                >
                  <CardContent sx={{ padding: "10px !important" }}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "start",
                        gap: 1.5,
                        padding: 0,
                      }}
                    >
                      <Box
                        sx={{
                          width: 100,
                          height: 100,
                          borderRadius: 1,
                          overflow: "hidden",
                          background: "#f1f5f9",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexShrink: 0,
                          padding: 0,
                        }}
                      >
                        {c.content?.imgUrl ? (
                          <img
                            src={c.content.imgUrl}
                            alt={c.title}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                          />
                        ) : (
                          <Email sx={{ color: "#64748b", fontSize: 20 }} />
                        )}
                      </Box>

                      <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Typography
                          variant="subtitle2"
                          sx={{
                            fontWeight: 600,
                            color: "#1e293b",
                            mb: 0.5,
                            fontSize: "1rem",
                          }}
                        >
                          {c.title}
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{
                            color: "#64748b",
                            fontSize: "0.8rem",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          Asunto: {c.subject}
                        </Typography>
                      </Box>

                      {isSelected && (
                        <CheckCircleIcon
                          sx={{
                            color: "#3b82f6",
                            fontSize: 20,
                            flexShrink: 0,
                          }}
                        />
                      )}
                    </Box>
                  </CardContent>
                </Card>
              );
            })}
        </Box>

        {selected && (
          <Box sx={{ mt: 3 }}>
            <Typography
              variant="subtitle2"
              sx={{
                mb: 1.5,
                fontWeight: 600,
                color: "#374151",
                fontSize: "0.9rem",
              }}
            >
              Vista previa
            </Typography>
            <Paper
              variant="outlined"
              sx={{
                minHeight: 180,
                maxHeight: 300,
                overflow: "auto",
                borderRadius: 1.5,
                background: "#fafafa",
              }}
            >
              <iframe
                srcDoc={templates[selected.template_html]}
                style={{
                  width: "100%",
                  height: "280px",
                  border: "none",
                  borderRadius: "6px",
                }}
                title="Template Preview"
              />
            </Paper>
          </Box>
        )}
      </Paper>

      {/* Panel derecho: Configuración */}
      <Paper
        elevation={1}
        sx={{
          flex: 1,
          p: 2.5,
          background: "rgba(255, 255, 255, 0.95)",
          backdropFilter: "blur(10px)",
          borderRadius: 2,
        }}
      >
        <Typography
          variant="h6"
          sx={{
            mb: 3,
            fontWeight: 600,
            color: "#1e293b",
            fontSize: "1.1rem",
          }}
        >
          Configurar Envío
        </Typography>

        {/* Archivos adjuntos */}
        <Box sx={{ mb: 3 }}>
          <Typography
            variant="subtitle2"
            sx={{
              mb: 1.5,
              fontWeight: 600,
              color: "#374151",
              fontSize: "0.9rem",
            }}
          >
            Archivos adjuntos
          </Typography>
          <Button
            variant="outlined"
            component="label"
            startIcon={<AttachFile sx={{ fontSize: 18 }} />}
            size="small"
            sx={{
              mb: 1.5,
              textTransform: "none",
              fontSize: "0.85rem",
              borderColor: "#d1d5db",
              color: "#374151",
              "&:hover": {
                borderColor: "#3b82f6",
                background: "#f8fafc",
              },
            }}
          >
            Adjuntar archivo
            <input type="file" hidden onChange={handleFileChange} />
          </Button>

          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
            {attachments.map((att, i) => (
              <Chip
                key={i}
                label={att.filename}
                size="small"
                sx={{
                  fontSize: "0.75rem",
                  height: 24,
                  "& .MuiChip-label": { px: 1 },
                }}
              />
            ))}
          </Box>
        </Box>

        {/* Documentación adjunta (solo renta_at2026) */}
        {selected?.template_html === "renta_at2026" && (
          <Box sx={{ mb: 3 }}>
            <Typography
              variant="subtitle2"
              sx={{
                mb: 1.5,
                fontWeight: 600,
                color: "#374151",
                fontSize: "0.9rem",
              }}
            >
              Documentación adjunta a mencionar
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 0.25 }}>
              {[
                { key: "incluir_balance_general", label: "Balance General" },
                { key: "incluir_libro_mayor", label: "Libro Mayor" },
                { key: "incluir_libro_diario", label: "Libro Diario" },
                { key: "incluir_certificados", label: "Certificados tributarios correspondientes" },
              ].map((opt) => (
                <FormControlLabel
                  key={opt.key}
                  control={
                    <Checkbox
                      size="small"
                      checked={Boolean(variables[opt.key])}
                      onChange={(e) => handleUpdateVar(opt.key, e.target.checked)}
                      sx={{
                        color: "#94a3b8",
                        "&.Mui-checked": { color: "#3b82f6" },
                      }}
                    />
                  }
                  label={
                    <Typography sx={{ fontSize: "0.85rem", color: "#374151" }}>
                      {opt.label}
                    </Typography>
                  }
                />
              ))}
            </Box>
          </Box>
        )}

        {/* Variables dinámicas */}
        <Box sx={{ mb: 3 }}>
          <Typography
            variant="subtitle2"
            sx={{
              mb: 1.5,
              fontWeight: 600,
              color: "#374151",
              fontSize: "0.9rem",
            }}
          >
            Variables de configuración
          </Typography>

          <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
            {Object.entries(variables)
              .filter(([key, value]) => typeof value !== "boolean" && !key.startsWith("incluir_"))
              .map(([key, value]) => (
              <Box
                key={key}
                sx={{ display: "flex", alignItems: "center", gap: 1.5 }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    minWidth: 100,
                    fontWeight: 500,
                    color: "#6b7280",
                    fontSize: "0.85rem",
                    fontFamily: "monospace",
                  }}
                >
                  {`{{${key}}}`}
                </Typography>
                <TextField
                  size="small"
                  placeholder={`Valor para ${key}`}
                  value={value}
                  onChange={(e) => handleUpdateVar(key, e.target.value)}
                  sx={{
                    flex: 1,
                    "& .MuiOutlinedInput-root": {
                      fontSize: "0.85rem",
                      "& fieldset": {
                        borderColor: "#d1d5db",
                      },
                    },
                  }}
                />
              </Box>
            ))}
          </Box>
        </Box>

        {/* Contenido del mensaje */}
        <Box sx={{ mb: 3 }}>
          <Typography
            variant="subtitle2"
            sx={{
              mb: 1.5,
              fontWeight: 600,
              color: "#374151",
              fontSize: "0.9rem",
            }}
          >
            Contenido del mensaje
          </Typography>

          <TextField
            label="Mensaje"
            multiline
            rows={4}
            fullWidth
            value={body}
            onChange={(e) => setBody(e.target.value)}
            sx={{
              mb: 1.5,
              "& .MuiOutlinedInput-root": {
                fontSize: "0.85rem",
                "& fieldset": {
                  borderColor: "#d1d5db",
                },
              },
            }}
          />
        </Box>

        {/* Botón de envío */}
        <Button
          variant="contained"
          startIcon={<SendIcon sx={{ fontSize: 18 }} />}
          onClick={handleSend}
          disabled={!selected}
          sx={{
            textTransform: "none",
            fontSize: "0.9rem",
            fontWeight: 600,
            py: 1,
            px: 3,
            background: "#10b981",
            "&:hover": {
              background: "#059669",
            },
            "&:disabled": {
              background: "#d1d5db",
              color: "#9ca3af",
            },
          }}
        >
          Enviar Campaña
        </Button>
      </Paper>
    </Box>
  );
};
